<lib-speed-monitor [mode]="screenMode" [workCenterId]="workCenterId"></lib-speed-monitor>
